import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import loc, { format } from 'owa-localize';
import { getRelativeDateMessage } from 'owa-observable-datetime';
import type { FileModifyInfo } from '../schema';
import { lastEditedBy } from '../filepickerStrings.locstring.json';

export default observer(function FileLinkModifyInfoView(props: FileModifyInfo) {
    const { lastModifiedBy, lastModifiedDate } = props;
    return !!lastModifiedBy && !!lastModifiedDate ? (
        <div className={styles.modifiedByContainer}>
            <div className={styles.modifiedBy}>
                {format(loc(lastEditedBy), lastModifiedBy.displayName)}
            </div>
            <div className={styles.modifiedBy}>{getRelativeDateMessage(lastModifiedDate)}</div>
        </div>
    ) : null;
});
